import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { VehicleHistoryReport } from '../../types';
import { CarfaxContainer, CarfaxIconWrapper } from './Carfax.styles';
import CarfaxUSIcon from '../../assets/icons/CarfaxUSIcon';
import CarfaxCAIcon from '../../assets/icons/CarfaxCAIcon';
import { SOURCE_CARFAX_US, SOURCE_CARPROOF_CA } from '../../constants';
import { TextLink } from '@oneaudi/unified-web-components';

export interface CarfaxProps {
  isCanadian: boolean;
  vehicleHistoryReports: VehicleHistoryReport[] | null | undefined;
}

const Carfax: React.FC<CarfaxProps> = ({ isCanadian, vehicleHistoryReports }) => {
  const { t } = useTranslation();

  const carfaxUrl = useMemo(() => {
    if (!vehicleHistoryReports?.length) return null;
    const sourceToFind = isCanadian ? SOURCE_CARPROOF_CA : SOURCE_CARFAX_US;
    const report = vehicleHistoryReports.find((r) => r.source === sourceToFind);
    return report?.url || null;
  }, [isCanadian, vehicleHistoryReports]);

  if (!carfaxUrl) return null;

  return (
    <CarfaxContainer>
      <CarfaxIconWrapper>{isCanadian ? <CarfaxCAIcon /> : <CarfaxUSIcon />}</CarfaxIconWrapper>
      <TextLink
        id="viewCarfaxReportButton"
        data-testid="view-carfax-report-button"
        aria-label={t('featuresAndSpecsSection.ariaLabel.carfax')}
        className="className"
        href={carfaxUrl}
        onClick={() => window.open(carfaxUrl, '_blank')}
        rel="noopener noreferrer"
        size="md"
        target="_blank"
        title="View Carfax Report"
        variant="standalone"
      >
        {t('featuresAndSpecsSection.categories.overview.headers.carfax')}
      </TextLink>
    </CarfaxContainer>
  );
};

export default Carfax;
